import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './InfoBanner.module.scss';

const cx = classnames.bind(styles);

const InfoBanner = ({
  className,
  color = 'pink',
  type = 'info',
  size = 'md',
  children
}) => {
  return (
    <div className={cx('root', `color-${color}`, `type-${type}`, `size-${size}`, className)}>
      <span aria-hidden={true} className={cx('info-icon', 'icon')}>i</span>
      {children}
    </div>
  )
}

InfoBanner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['pink', 'blue', 'b2b']),
  type: PropTypes.oneOf(['info']),
  size: PropTypes.oneOf(['sm', 'md'])
}

export default InfoBanner;
